var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLevrageLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9577 6.3724C14.9577 8.76573 13.0177 10.7057 10.6243 10.7057C10.511 10.7057 10.391 10.6991 10.2777 10.6924C10.111 8.57907 8.41768 6.88572 6.30434 6.71906C6.29767 6.60572 6.29102 6.48573 6.29102 6.3724C6.29102 3.97906 8.23102 2.03906 10.6243 2.03906C13.0177 2.03906 14.9577 3.97906 14.9577 6.3724Z",
    stroke: "#A5B5BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2917 11.0394C10.2917 13.4327 8.35167 15.3727 5.95833 15.3727C3.565 15.3727 1.625 13.4327 1.625 11.0394C1.625 8.64605 3.565 6.70605 5.95833 6.70605C6.07167 6.70605 6.19166 6.71271 6.30499 6.71938C8.41833 6.88605 10.1117 8.5794 10.2783 10.6927C10.285 10.8061 10.2917 10.9261 10.2917 11.0394Z",
    stroke: "#A5B5BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37101 10.453L5.95768 9.37305L6.54435 10.453L7.62435 11.0397L6.54435 11.6264L5.95768 12.7064L5.37101 11.6264L4.29102 11.0397L5.37101 10.453Z",
    stroke: "#A5B5BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevrageLight);
export default __webpack_public_path__ + "static/media/levrageLight.362bd968bcdfece05ba731d9ffb6756b.svg";
export { ForwardRef as ReactComponent };